@if (score && score.currentlyServing) {
    <div class="column sets basepad">
        <div class="cell" [class.hidden-visibility]="score.currentlyServing !== 1">
            @if (!isBaseVisible) {
                <div class="{{ homeTeamBase }}"></div>
            } @else {
                <vn-icon class="baseball-indicator" size="12" [name]="homeTeamBase"></vn-icon>
            }
        </div>
        <div class="cell" [class.hidden-visibility]="score.currentlyServing !== 2">
            @if (!isBaseVisible) {
                <div class="{{ awayTeamBase }}"></div>
            } @else {
                <vn-icon class="baseball-indicator" size="12" [name]="awayTeamBase"></vn-icon>
            }
        </div>
    </div>
}
@if (games) {
    <div class="column sets">
        <div class="cell"><div [msValueSlider]="games!.participant1"></div></div>
        <div class="cell"><div [msValueSlider]="games!.participant2"></div></div>
    </div>
}
